import { enableButtonClickTrackingTypeSafe, enableFormTrackingTypeSafe, enableLinkClickTrackingTypeSafe } from '../typesafe-self-describing-event-tracker';
export const pluginRegistry = {
    activityTracking: {
        plugin: async () => null,
        enable: async (config) => {
            if (typeof window !== 'undefined' && config) {
                const { enableActivityTracking } = await import('@snowplow/browser-tracker');
                enableActivityTracking(config);
            }
        }
    },
    buttonClickTracking: {
        plugin: async () => {
            if (typeof window !== 'undefined') {
                const { ButtonClickTrackingPlugin } = await import('@snowplow/browser-plugin-button-click-tracking');
                return ButtonClickTrackingPlugin();
            }
            return null;
        },
        enable: async (config) => {
            if (typeof window !== 'undefined') {
                await enableButtonClickTrackingTypeSafe(config);
            }
        }
    },
    linkClickTracking: {
        plugin: async () => {
            if (typeof window !== 'undefined') {
                const { LinkClickTrackingPlugin } = await import('@snowplow/browser-plugin-link-click-tracking');
                return LinkClickTrackingPlugin();
            }
            return null;
        },
        enable: async (config) => {
            if (typeof window !== 'undefined') {
                await enableLinkClickTrackingTypeSafe(config);
            }
        }
    },
    formTracking: {
        plugin: async () => {
            if (typeof window !== 'undefined') {
                const { FormTrackingPlugin } = await import('@snowplow/browser-plugin-form-tracking');
                return FormTrackingPlugin();
            }
            return null;
        },
        enable: async (config) => {
            if (typeof window !== 'undefined') {
                await enableFormTrackingTypeSafe(config);
            }
        }
    },
    siteSearchTracking: {
        plugin: async () => {
            if (typeof window !== 'undefined') {
                const { SiteTrackingPlugin } = await import('@snowplow/browser-plugin-site-tracking');
                return SiteTrackingPlugin();
            }
            return null;
        }
    },
    vimeoTracking: {
        plugin: async () => {
            if (typeof window !== 'undefined') {
                const { VimeoTrackingPlugin } = await import('@snowplow/browser-plugin-vimeo-tracking');
                return VimeoTrackingPlugin();
            }
            return null;
        }
    },
    html5MediaTracking: {
        plugin: async () => {
            if (typeof window !== 'undefined') {
                const { MediaTrackingPlugin } = await import('@snowplow/browser-plugin-media-tracking');
                return MediaTrackingPlugin();
            }
            return null;
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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